import React  from 'react'
import { useFeiyongSHMutation,} from '../../store/NeiZhangFeiYongApi'
import {App} from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons';

function ExpenseAudit(props) {
    const {message,modal} = App.useApp()
    const [submitDel] = useFeiyongSHMutation()  
    return (
        <>
            {!props.fysh_data?.some(item => item.fysh_uname.includes(props.eu_name)) &&
                       <a onClick={() => {
                            modal.confirm({
                                title: '审核费用',
                                content: '你确定要审核这条记录吗？审核后的费用报销单不能修改和删除，取消审核需要有权限的用户操作。',
                                okText: '确定',
                                cancelText: '取消', 
                                onOk: () => {
                                    submitDel({
                                        fysh_fy_id: props.fy_id,
                                        fysh_uid: props.eu_id,
                                        fysh_uname: props.eu_name,
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.success('审核成功!')                                            
                                        }
                                        if (res.data.Status === "fail" && res.data.Message === "创建人未审核，审核失败") {
                                            modal.error({
                                                title: '审核失败!',
                                                content: '费用的新增用户审核后，其他用户才能审核。',
                                            });
                                        }
                                        if (res.data.Status === "fail" && res.data.Message === "创建人已审核过了") {
                                            modal.warning({
                                                title: '请勿重复提交!',
                                                content: '你已经审核过了。',
                                            });
                                        }
                                    })
                                },
                            });
                        
                        }}><CheckCircleOutlined /> 审核</a>
            }
        </>
    )
}

export default ExpenseAudit